const StoreLink = 'https://www.cnyes.com/anuestore/subscribe/19/about';
const FreeVersionLink = 'https://www.cnyes.com/anuestore/subscribe/19/free';

export { FreeVersionLink, StoreLink };